import withGS from './withGShoc';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { globalStyles } from './style/gstheme';
import AnnotateIcon from './icons/Annotate';

const styles = () => {
  return Object.assign({
    annotate: {
      backgroundColor: '#84BC01',
      borderTopLeftRadius: 12,
      borderBottomLeftRadius: 12,
      height: 24,
      paddingLeft: 4,
      display: 'inline-block',
      transform: 'translateY(1px)',
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: '#97d700'
      }
    },
    deprecatedAnnotate: {
      backgroundColor: '#CA4F0C',
      borderTopLeftRadius: 12,
      borderBottomLeftRadius: 12,
      height: 24,
      paddingLeft: 4,
      display: 'inline-block',
      transform: 'translateY(1px)',
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: '#ff8000'
      }
    }
  }, globalStyles);
};

class ReifyButtonInner extends Component {

  render() {

    const { data, classes } = this.props;
    const deprecated = data.deprecated;


    return (
      <span
        className={deprecated ? classes.deprecatedAnnotate : classes.annotate}
        data-test={deprecated ? "deprecated-annotation" : "annotation"}>
        <span
          style={{
            color: 'white'
          }}>
          <AnnotateIcon />
        </span>
      </span>
    );
  }
}


ReifyButtonInner.propTypes = {
  classes: PropTypes.object
};

export default withStyles(styles)(withGS(ReifyButtonInner, ["ALL"], null, {}, false));